(function () {
    'use strict';

    angular.module('SMART2').factory('cellTemplateProvider', ['$filter', '$translate', 'smartDateFormatFilter', function ($filter, $translate, smartDateFormatFilter) {
        function applyLocalizationFilter(text) {
            return $filter('translate')(text);
        };

        function _getCellTemplate(config, templateType) {
            if (config.type == 'calculated') {
                if (config.field && config.field != 'IsCloseForReceiving' && config.field != 'IsCloseForInvoicing') {
                    return '<div ng-class="{\'text-strikethrough\': row.entity.ItemStatus.id===121}"><div ng-if="!row.groupHeader" >{{' + config.attributes.rule + '|  minPrecisionHandler:' + config.attributes.minmaxprecisionfilter + '}}</div></div>';
                }
                else {
                    return '<div ng-class="{\'text-strikethrough\': row.entity.ItemStatus.id===121}"><div ng-if="!row.groupHeader" >{{' + config.attributes.rule + '}}</div></div>';
                }
            }
            else if (config.type == 'editable') {

                if (config.attributes && config.attributes.type && config.attributes.type == "number") {
                    if (templateType == "cellTemplate" && config.align=="left") {
                        return '<div ng-class="{\'text-strikethrough\': row.entity.ItemStatus.id===121, \'ui-grid-cell-contents paddingRight5\': true}" ng-style="{color: COL_FIELD === \'\' || COL_FIELD == undefined || COL_FIELD == null ? \'transparent\' : \'\'}" title="{{COL_FIELD}}">{{COL_FIELD === \'\' || COL_FIELD == undefined || COL_FIELD == null ? \'-\' : row.entity.' + (config.data != undefined ? config.data : config.field) + '}}</div>'
                    }else if (templateType == "cellTemplate") {
                        return '<div ng-class="{\'text-strikethrough\': row.entity.ItemStatus.id===121, \'ui-grid-cell-contents right-align paddingRight5\': true}" ng-style="{color: COL_FIELD === \'\' || COL_FIELD == undefined || COL_FIELD == null ? \'transparent\' : \'\'}" title="{{COL_FIELD}}">{{COL_FIELD === \'\' || COL_FIELD == undefined || COL_FIELD == null ? \'-\' : row.entity.' + (config.data != undefined ? config.data : config.field) + '}}</div>'
                    }
                    else if (templateType == "editableCellTemplate") {
                        //var min = "";
                        //min = config.attributes.minValue ? 'min="' + config.attributes.minValue + '"' : "";
                        var minimumPrecision = "";
                        if (config.attributes.minmaxprecision != undefined)
                            minimumPrecision = 'minmaxprecision="' + config.attributes.minmaxprecision + '"';
                        var maxlength = "";
                        if (config.attributes.maxlength != undefined)
                            maxlength = 'maxlength="' + config.attributes.maxlength + '"';

                        return '<div title="{{COL_FIELD }}"><div><smart-textfield  class="ui-grid-cell-contents" type="number" focus="true" ' + minimumPrecision + ' ng-model="row.entity.' + config.field + '" ' + maxlength + ' on-key-up="grid.appScope.textOrNumberKeyUp($event,col,row)" zero-case-handler uigrid-compatible></smart-textfield></div></div>';
                    }
                }
                else if (config.attributes && config.attributes.type && config.attributes.type == "autocomplete") {
                    if (templateType == "cellTemplate") {
                        return '<div ng-class="{\'text-strikethrough\': row.entity.ItemStatus.id===121, \'padding0\': true}" ng-style="{color: COL_FIELD === \'\' || COL_FIELD == undefined || COL_FIELD == null ? \'transparent\' : \'\'}" title="{{COL_FIELD}}">{{COL_FIELD === \'\' || COL_FIELD == undefined || COL_FIELD == null ? \'-\' : COL_FIELD}}</div>';
                    }
                    else if (templateType == "editableCellTemplate") {
                        return '<div class="padding0" title="{{COL_FIELD}}"><div><smart-textfield class="ui-grid-cell-contents" type="autocomplete" width="230px" ' +
                    ' displayformat="' + config.attributes.displayformat + '" optionformat="' + config.attributes.optionformat + '" filterkeys="' + ("['" + config.attributes.filterkeys.join("','") + "']") +
                    '" ng-model="row.entity.' + config.attributes.model + '" options="grid.appScope.autoSuggestOptions"  on-change="grid.appScope.autoSuggestOnChange($event,col,row)" on-select="grid.appScope.autoSuggestOnSelect($event,row.entity.' + config.attributes.model + ',row,col)" uigrid-compatible></smart-textfield></div></div>';
                    }
                }
                else if (config.attributes && config.attributes.type && config.attributes.type == "date") {
                    if (templateType == "cellTemplate") {
                        return "<div  ng-class='{\"text-strikethrough\": row.entity.ItemStatus.id===121}' ng-style='{color: COL_FIELD === \"\" || COL_FIELD == undefined || COL_FIELD == null ? \"transparent\" : \"\", height: \"100%\"}'>{{COL_FIELD === \'\' || COL_FIELD == undefined || COL_FIELD == null ? \'-\' : (COL_FIELD | smartDateFormat:'" + config.attributes.format + "')}}</div>";
                    } else if (templateType == "editableCellTemplate") {
                        return '<div grid-date-template-provider></div>'
                    }
                }
                var maxlength = "";
                if (config.attributes.maxlength != undefined)
                    maxlength = 'maxlength="' + config.attributes.maxlength + '"';
                if (templateType == "cellTemplate") {
                    return '<div ng-class="{\'text-strikethrough\': row.entity.ItemStatus.id===121, \'padding0\': true}" ng-style="{color: COL_FIELD === \'\' || COL_FIELD == undefined || COL_FIELD == null ? \'transparent\' : \'\'}" title="{{COL_FIELD | translate}}">{{COL_FIELD === \'\' || COL_FIELD == undefined || COL_FIELD == null ? \'-\' : (row.entity.' + (config.data != undefined ? config.data : config.field) + ' | translate)}}</div>';
                } else if (templateType == "editableCellTemplate") {
                    return '<div title="{{COL_FIELD}}"><div><smart-textfield class="ui-grid-cell-contents" type="text"' +
                                        ' ng-model="row.entity.' + config.field + '" ' + maxlength + ' on-key-up="grid.appScope.textOrNumberKeyUp($event,col,row)" uigrid-compatible></smart-textfield></div></div>';
                }

            } else if (config.type == 'dropdown') {
                config.attributes.options.map(function (x) { x[config.attributes.datakey] = $filter('translate')(x[config.attributes.datakey]) });
                if (templateType == "cellTemplate") {
                    return "<div ng-class='{\"text-strikethrough\": row.entity.ItemStatus.id===121}'><div ng-if='grid.appScope.isObject(COL_FIELD)' style='height:100%;' uigrid-compatible>{{COL_FIELD." + config.attributes.dataKey + " | translate}}</div><div ng-if='!grid.appScope.isObject(COL_FIELD)' IDK={{" + config.attributes.idKey + "}} style='height:100%;' uigrid-compatible>{{COL_FIELD | translate}}</div></div>";
                }
                else if (templateType == "editableCellTemplate") {
                    return "<div class='ui-grid-cell-contents'><form name='inputForm'><select model = {{row.entity." + config.attributes.model + "}} ui-grid-edit-dropdown ng-model='row.entity." + config.attributes.model + "' ng-change='grid.appScope.dropDownOnChange(row.entity, col , row.entity." + config.field + ")' ng-options='option." + config.attributes.dataKey + " for option in grid.appScope.dropDownOptions track by option." + config.attributes.idKey + "' uigrid-compatible></select></form></div>";
                }
            } else if (config.type == 'checkbox') {
                if (templateType == "cellTemplate") {
                    return '<div title="{{COL_FIELD}}"><div><smart-checkbox fill="true" class="ui-grid-cell-contents" ng-model="row.entity.' + config.attributes.model +
                        '" on-change="grid.appScope.checkBoxOnChange(row.entity, col , row.entity.' + config.field + ')"  uigrid-compatible></smart-checkbox></div></div>';
                }
            } else if (config.type == 'popup') {
                var displayLabel = "";
                var appendingString = "\+\"-\"\+";
                if (typeof config.appendedLabels != "undefined") {
                    for (var i = 0; i < config.appendedLabels.length; i++) {
                        displayLabel = displayLabel + 'row.entity.' + config.appendedLabels[i] + appendingString;
                    }
                    displayLabel = "(" + displayLabel.slice(0, -(appendingString.length)) + ")";

                }
                else {
                    displayLabel = (templateType == "cellTemplate") ? ("row.entity." + config.field) : 'COL_FIELD';
                }

                var defaultLabel = "\"" + config.attributes.defaultTitle + "\"";
                if (typeof config.attributes.defaultLabelCondition != "undefined") {
                    var defaultLabel = config.attributes.defaultLabelCondition;
                }


                if (templateType == "cellTemplate") {
                    if (config.attributes.type === 'categoryPopup')
                        return '<div title = "{{COL_FIELD}}" class="ui-grid-cell-contents padding0"><a ng-if="!row.groupHeader" ng-class="{\'waves-effect waves-light btn-flat\': true, \'disabled\': row.entity.source.id!==1,\'text-strikethrough\': row.entity.ItemStatus.id===121}">{{(COL_FIELD != undefined && (COL_FIELD != "") && (COL_FIELD != "1")) ?' + displayLabel + ' : ' + defaultLabel + '}}</a></div>';
                    else
                        return '<div title = "{{COL_FIELD}}" class="ui-grid-cell-contents padding0"><a ng-if="!row.groupHeader" ng-class="{\'waves-effect waves-light btn-flat\': true, \'disabled\': ' + !config.enableCellEdit + ',\'text-strikethrough\': row.entity.ItemStatus.id===121}">{{(COL_FIELD != undefined && (COL_FIELD != "") && (COL_FIELD != "1")) ?' + displayLabel + ' : ' + defaultLabel + '}}</a></div>';


                }
                else if (templateType == "editableCellTemplate") {
                    return '<div title="{{COL_FIELD}}"><smart-button flat="true"  config=\'{"title": (row.entity.' + config.field + ' != undefined && row.entity.' + config.field + ' != "1" && row.entity.' + config.field + ' != "")?' + displayLabel + ' : ' + defaultLabel + ' }\' on-click="grid.appScope.popUpButtonClickCallback(row,col)" uigrid-compatible></smart-button></div>';
                }
            } else if (config.type == 'subsection' && config.data == 'notes') {
                if (config.data && config.attributes && config.attributes.readonly !== undefined) {
                    return '<div><smart-button flat="true" disable="grid.appScope.IsCellReadOnly(row.entity' + ',\'' + config.data + '\',' + config.attributes.readonly + ')" config=\'{"title":grid.appScope.getCommentText(row.entity.notes)}\' callback-params="row.entity"} callback="grid.appScope.showCommentsPopupCallback"  uigrid-compatible></smart-button><div>';
                }
            } else if (config.type == 'subsection' && config.data == 'manufacturer') {
                if (config.data && config.attributes && config.attributes.readonly !== undefined) {
                    return '<div title="{{COL_FIELD}}"><smart-button flat="true" disable="grid.appScope.IsCellReadOnly(row.entity' + ',\'' + config.data + '\',' + config.attributes.readonly + ')" config=\'{"title":grid.appScope.setManufacturerDisplayName(row.entity)}\' callback-params="row.entity" callback="grid.appScope.showManufacturerPopupCallback"  uigrid-compatible></smart-button><div>';
                }
            } else if (config.data == 'splitType') {
                if (config.data && config.attributes && config.attributes.readonly !== undefined) {
                    return '<div title="{{COL_FIELD}}"><smart-button flat="true" disable="grid.appScope.IsCellReadOnly(row.entity' + ',\'' + config.data + '\',' + config.attributes.readonly + ')"  config=\'{"title":grid.appScope.splitType(row.entity.splitType)}\'  callback-params="row.entity"} callback="grid.appScope.showSplitsPopup"  uigrid-compatible></smart-button><div>';
                } else {
                    return '<div title="{{COL_FIELD}}"><smart-button flat="true" config=\'{"title":grid.appScope.splitType(row.entity.splitType)}\'  callback-params="row.entity"} callback="grid.appScope.showSplitsPopup"  uigrid-compatible></smart-button><div>';
                }
            } else if (config.data == 'splitValue') {
                //return '<div title="{{COL_FIELD}}" class="ui-grid-cell-contents">{{grid.appScope.getSplitValue(row.entity)}}</div>';
                return '<div title="{{COL_FIELD | minPrecisionHandler: ' + config.attributes.minmaxprecisionfilter + '}}" class="ui-grid-cell-contents">{{grid.appScope.getSplitValue(row.entity) | minPrecisionHandler: ' + config.attributes.minmaxprecisionfilter + '}}</div>';
            } else if (config.data == 'taxes') {
                if (config.data && config.attributes && config.attributes.readonly !== undefined) {
                    return '<div title="{{COL_FIELD}}"><smart-button flat="true" disable="grid.appScope.IsCellReadOnly(row.entity' + ',\'' + config.data + '\',' + config.attributes.readonly + ')" config=\'{"title":grid.appScope.showExempted(row.entity)}\' callback-params="row.entity"} callback="grid.appScope.openTaxPopup"  uigrid-compatible></smart-button></div>';
                }
            } else if (config.data == 'total') {
                return '<div title="{{COL_FIELD | minPrecisionHandler:' + config.attributes.minmaxprecisionfilter + '}}" class="ui-grid-cell-contents">{{grid.appScope.getTotal(row.entity) | minPrecisionHandler:' + config.attributes.minmaxprecisionfilter + '}}</div>';
            }
        }

        var serviceObj = {
            getCellTemplate: _getCellTemplate
        };

        return serviceObj;
    }]);

    angular.module('SMART2').directive('gridDateTemplateProvider', ['$rootScope', '$timeout', '$filter', function ($rootScope, $timeout, $filter) {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                scope.onDateChange = function (date) {
                    if (date != '') {
                        scope.row.entity[scope.col.colDef.field] = getServerDateFormat(date);
                        $rootScope.$broadcast("closedPopup");
                    }
                }
                function getServerDateFormat(value) {
                    if (value) { } else {
                        //current date or 0
                        value = 0;
                    }
                    var serverDateInNumber = getServerDateInNumber(value);
                    if (serverDateInNumber) {
                        return "\/Date(" + serverDateInNumber + ")\/";
                    } else {
                        return serverDateInNumber;
                    }
                };

                function getServerDateInNumber(value) {
                    //CONVERT DATE FROM ALMOST ANY VALID DATE FORMAT TO "/Date(1455883450840+0000)/" form
                    var IS_UNEXPECTED_DATE_VALUE = false;
                    if (value) {
                        if ((typeof value).toLowerCase() === "string") {
                            if (value.indexOf("Date") > -1) {
                                var a = (value + '').replace(new RegExp("/", "ig"), '');
                                a = a.split('+');
                                var b = eval('new ' + a[0] + (a.length > 1 ? ')' : ''));
                            } else {
                                IS_UNEXPECTED_DATE_VALUE = true;
                            }
                        } else {
                            IS_UNEXPECTED_DATE_VALUE = true;
                        }
                        if (IS_UNEXPECTED_DATE_VALUE) {
                            if (isNaN(new Date(value))) {
                                return new Date(0).getTime();
                            } else {
                                var b = new Date(value);
                            }
                        }
                        return b.getTime();
                    } else {
                        return null;
                    }
                };
            },
            template: '<div style="width:100%;height:100%" ><smart-textfield focus="" set-from-grid=true on-date-change="onDateChange($date)" type="date" ng-model="row.entity[col.colDef.field]" format="{{col.colDef.attributes.format}}" uigrid-compatible></smart-textfield></div>'
        };
    }]);

    angular.module('SMART2').filter('smartDateFormat', ['$filter', 'Common', function ($filter, Common) {
        return function (input, format) {
            var outputDate;
            try {
                if (input) {
                    var b = Common.convertServerDateTimeToNormalDateTime(input);
                    if (!_.contains(format.split(' '), 'hh:mm')) {
                        b = new Date(b.getFullYear(), b.getMonth(), b.getDate());
                    }
                    outputDate = $filter('date')(b, format); //, timezone)
                } else {
                    outputDate = "";
                }
            }
            catch (e) {
                outputDate = input;
            }
            return outputDate;
        };
    }]);

    angular.module('SMART2').directive('zeroCaseHandler', [function zeroCaseHandler() {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                ctrl.$parsers.push(function (value) {
                    if (isNaN(value)) {
                        return 0;
                    }
                    return value;
                });
            }
        };
    }]);



})();

